// extracted by mini-css-extract-plugin
export default {"warningBadge":"WarningBadge_warningBadge__8Sfru"};